import React from "react";
import PropTypes from "prop-types";
import { filterNutrientsByNutrientsNames, kcalToKj } from "~/assets/js/Format";
import { nutrientNamesTranslations } from ".";

const CurrentProduct = ({ product }) => {
    const { details } = product;
    const calculatePerServing = (nutrients) => {
        let nutrientsPerServing = {};

        Object.keys(nutrients).map((key) => {
            if (null === details.weight) {
                nutrientsPerServing[key] = "~";
            } else {
                const value = nutrients[key];
                nutrientsPerServing[key] = Math.round(
                    (value / 100) * details.weight
                );
            }
        });

        return nutrientsPerServing;
    };

    const nutrients = filterNutrientsByNutrientsNames(details);
    const nutrientsPerServing = calculatePerServing(nutrients);

    return (
        <>
            <div className="product-nutrients-table__container">
                <table className="product-nutrients-table has-background">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Pro 100 g</th>
                            <th>{`1 Portion (${details.weight ?? "~"} g) `}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(nutrients).map((key) => {
                            if (key === "energy") {
                                return (
                                    <tr
                                        className="product-nutrients-table__summary"
                                        key={key}
                                    >
                                        <td>
                                            {nutrientNamesTranslations[key]}
                                        </td>
                                        <td>
                                            <p className="kcal">
                                                {nutrients[key] ?? "~"} kcal
                                            </p>
                                            <p>{kcalToKj(nutrients[key])} kJ</p>
                                        </td>
                                        <td>
                                            <p className="kcal">
                                                {nutrientsPerServing[key]} kcal
                                            </p>
                                            <p>
                                                {kcalToKj(
                                                    nutrientsPerServing[key]
                                                )}{" "}
                                                kJ
                                            </p>
                                        </td>
                                    </tr>
                                );
                            }

                            return (
                                <tr key={key}>
                                    <td>{nutrientNamesTranslations[key]}</td>
                                    <td>{nutrients[key] ?? "~"}</td>
                                    <td>{nutrientsPerServing[key]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

const attributeType = {
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
};

const productType = {
    attributes: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    content: PropTypes.string,
    image: PropTypes.string,
    intolerance: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    priceGross: PropTypes.string,
    priceNet: PropTypes.string,
    taxRate: PropTypes.string,
    title: PropTypes.string,
};

CurrentProduct.propTypes = {
    product: PropTypes.shape(productType),
};

export default CurrentProduct;
